// tslint:disable: trailing-comma
// tslint:disable:no-any
import { IPrice } from './price.interface';

export interface ISalesDocument {
  salesDocumentId: number;
  salesDocumentType: {
    links: any
    salesDocumentTypeId: number
  };
  salesDocumentItemId: number;
  salesDocumentItemCode: string;
  salesDocumentCode: string;
  purchaseOrderCode: string;
  shipmentLocation: {
    links: any
    shipmentLocationId: number
    shipmentLocationType: {
      links: any
      shipmentLocationTypeId: number
    }
  };
  salesDocumentValidity: {
    from: string
    to: string
  };
  volume: {
    total: {
      quantity: {
        amount: number
        unitOfMeasure: {
          links: any
          unitId: number
        }
      }
      price: IPrice
    }
  };
  paymentTerm: {
    links: any
    paymentTermId: number
    checkPaymentTerm: boolean
  };
  shippingCondition: {
    links: any
    shippingConditionId: number
    checkShippingCondition: boolean
  };
  hasBalance: boolean;
  salesDocumentCategory: {
    salesDocumentCategoryDesc: string
  };
}
